import { gsap } from "gsap";
import { isElement } from '../../utils';
import debounce from 'lodash.debounce';

let fixedEl = null;
let triggerEl = null;
let triggerMedia = null;
let triggerMediaRect = null;
let headerMedia = null;
let headerMediaWidth = null;
let headerMediaHeight = null;
let headerMediaLeft = null;

function matchesTrigger(el) {
	const selectors = ['[data-to-case-transition]'];
	return selectors.some(selector => el.matches(selector));
}

function getTrigger(trigger) {
	if (trigger.matches('.c-home-featured-case__link')) {
		return trigger.closest('[data-home-featured-cases-case]');
	} else {
        return trigger;
    }
}

function checkMaskState(trigger) { // Default transition when Home Featured Cases is not 'Full'
    let toCase = true;
    const featuredCasesParent = trigger.closest('[data-home-featured-cases]');
    if(featuredCasesParent) {
        const maskState = featuredCasesParent.getAttribute('data-mask');
        if(maskState!='full') {
            toCase = false;
        }
    }
    return toCase;
}

function handleNewViewheight() {
    document.removeEventListener('scroll', this.boundHandleNewViewheight);
    window.scrollTo(0, -1);
}

export default {
	name: 'to-case',
    from: {
		custom: ({ current, next, trigger }) => {
			return isElement(trigger) && matchesTrigger(trigger) && checkMaskState(trigger);
		},
	},
    before({ current, next, trigger }) {
        return new Promise(resolve => {
            triggerEl = getTrigger(trigger);
            triggerEl.style.pointerEvents = 'none';
            triggerEl.blur();
            triggerEl.classList.remove('c-home-featured-case--visible');

            let delay = 400;
            setTimeout(() => {
                resolve();
            }, delay);

            // Fix for ios adress bar drop causing the new page not to start at the top
            this.boundHandleNewViewheight = debounce(handleNewViewheight.bind(this), 100);
            document.addEventListener('scroll', this.boundHandleNewViewheight);
        });
    },
    leave({ current, next, trigger }) {
        return new Promise(resolve => {

            triggerMedia = triggerEl.querySelector('[data-case-transition-media]');
            triggerMediaRect = triggerMedia.getBoundingClientRect();

            fixedEl = document.createElement('div');
            const dummy = document.createElement('div');
            dummy.style.width = `${triggerMediaRect.width}px`;
            dummy.style.height = `${triggerMediaRect.height}px`;

            document.body.appendChild(fixedEl);

            // Insert dummy and move triggerEl to fixed overlay
            if(triggerEl.classList.contains('c-home-featured-case')) {
                fixedEl.classList.add('case-transition-fixed-container-home');
            } else {
			    fixedEl.classList.add('case-transition-fixed-container');
            }

            fixedEl.style.width = `${triggerMediaRect.width}px`;
            fixedEl.style.height = `${triggerMediaRect.height}px`;
            fixedEl.style.left = `${triggerMediaRect.x}px`;
            fixedEl.style.top = `${triggerMediaRect.y}px`;

            triggerMedia.parentElement.insertBefore(dummy, triggerMedia);
            fixedEl.appendChild(triggerMedia);

			resolve();
		});
    },
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

            next.container.classList.add('to-case-transition-absolute');
            gsap.set(next.container.querySelector('#smooth-wrapper'), {
            	opacity: 0,
            });

            const caseHeader = next.container.querySelector('[data-case-header]');
            headerMedia = caseHeader.querySelector('[data-case-transition-media]');
            headerMedia.innerHTML = '';

            // Calculate Case Header Media Size
            const breakpoint = window.matchMedia('(max-width:767px)');
            if(breakpoint.matches === true) {
                headerMediaWidth = ((document.body.clientWidth/100)*90);
                headerMediaHeight = headerMediaWidth*1.4;
                headerMediaLeft = ((document.body.clientWidth/100)*5);
            } else {
                headerMediaWidth = ((document.body.clientWidth/100)*95);
                headerMediaHeight = headerMediaWidth/2;
                headerMediaLeft = ((document.body.clientWidth/100)*2.5);
            }
            const headerMediaTop = document.querySelector('[data-header]').getBoundingClientRect().height;
            const dummyHeaderYDifference = headerMediaTop-triggerMediaRect.top;
            const dummyHeaderXDifference = headerMediaLeft-triggerMediaRect.left;

            this.tl = gsap.timeline({
                onStart: () => {
                    document.body.classList.remove('body--inverted');
                    document.body.classList.remove('body--header-inverted');
                },
                onComplete: () => {
                    gsap.set(current.container, {
                        opacity: 0,
                    });
                    resolve();
                }
            });

            // Move Dummy Media To Same Position as Header Media
            this.tl.to(fixedEl, {
                translateY: dummyHeaderYDifference,
                translateX: dummyHeaderXDifference,
                duration: 1,
                delay: 0,
                ease: 'power4.inOut',
            });

            // Adjust Dummy Media To Same Size as Header Media
            this.tl.to(triggerMedia, {
                width: headerMediaWidth,
                height: headerMediaHeight,
                duration: 1,
                delay: 0,
                ease: 'power4.inOut',
            }, '0');

            // Hide Current Container
            this.tl.to(current.container.querySelector('main'), {
                translateY: dummyHeaderYDifference,
                opacity: 0,
                duration: 1,
                delay: 0,
                ease: 'power4.inOut',
            }, '0');

		});
	},
    beforeEnter({ current, next, trigger }) {
        return new Promise(resolve => {

            // Show Next Container
            gsap.to(next.container.querySelector('#smooth-wrapper'), {
                opacity: 1,
                ease: 'sine.in',
                duration: 0.4,
                onComplete: () => {
                    // Replace Header Media with Original Media
                    headerMedia.parentElement.insertBefore(triggerMedia, headerMedia);
                    headerMedia.remove();
                    fixedEl.remove();

                    triggerMedia.style.removeProperty('width');
                    triggerMedia.style.removeProperty('height');

                    resolve();
                }
            });

        });
    },
	after({ current, next, trigger }) {
        return new Promise(resolve => {
            next.container.classList.remove('to-case-transition-absolute');
            resolve();
        });
	},
};
